interface Path {
    [key: string]: {
        path: string;
        routes?: Path;
    };
}

const pathsConfig = {
    BASE: { path: '/' },
    HOME: { path: '/home' },
    TRENDING: {
        path: '/trending',
        routes: {
            HASHTAGS: {
                path: '/hashtags',
            },
            MUSIC: {
                path: '/music',
            },
            CREATOR: {
                path: '/creator',
            },
        },
    },
    INSPIRATION: {
        path: '/inspiration',
        routes: {
            POPULARADS: {
                path: '/popularads',
            },
            CREATIVESTRATEGY: {
                path: '/creativestrategy',
            },
            ExcitingVideo: {
                path: '/excitingvideo',
            },
        },
    },
    INFODETAIL: {
        path: '/detail',
        routes: {
            CREATORDETAIL: {
                path: '/creator',
            },
            HASHTAGDETAIL: {
                path: '/hashtags',
            },
            MUSICDETAIL: {
                path: '/music',
            },
            VIDEODETAIL: {
                path: '/video',
            },
            ADDETAIL: {
                path: '/ad',
            },
        },
    },
    CRETIVETOOL: {
        path: '/cretivetool',
    },
    CREATIVEPURCHASING: {
        path: '/creativepurchasing',
    },
    PERSONAL: {
        path: '/personal',
        // routes: {
        //     ADMANAGEMENT: {
        //         path: '/ad-management'
        //     }
        // },
    },
    // CREATIVEPURCHASING: {
    //     path: '/creativepurchasing',
    // },
} as const;

function formatPath<T extends Path>(paths: T, parentPath?: string): T {
    Object.keys(paths).forEach((key) => {
        const { path, routes } = paths[key];
        if (parentPath) {
            paths[key].path = `${parentPath}${path}`;
        }
        if (routes) {
            paths[key].routes = formatPath(routes, paths[key].path);
        }
    });
    return paths;
}

const paths = formatPath(pathsConfig);

export { paths };
